import { Fragment } from 'react'
import { Properties } from 'types/onboarding'
import { CheckLarge } from '../check-large/CheckLarge'
import { Modal } from 'components/modal/Modal'
import { PackageList } from './PackageList'
import TransparentButton from 'components/new-buttons/TransparentButton'
import { mapProductName } from './Address'
import AccordionContainer from './AccordionContainer'
import { PackageAccordion } from './PackageAccordion'
import { useResize } from 'hooks/useResize'
import { useSelectPackages } from 'hooks/onboarding/useSelectPackages'
import styles from './SelectPackage.module.scss'

interface SelectPackageProps {
  setProperties: (newProperties: Properties) => void
  properties: Properties
  offerType: string | null | undefined
}

export const SelectPackage = ({
  properties,
  setProperties,
  offerType,
}: SelectPackageProps) => {
  const { isMobile } = useResize()

  const {
    modalVisible,
    setModalVisible,
    activeProperty,
    setActiveProperty,
    selectCheckbox,
    selectProduct,
    findProduct,
  } = useSelectPackages({ setProperties, properties })

  const showModalButton = (product?: string) => {
    if (offerType === 'svellid') {
      return undefined
    }
    return product ? mapProductName(product) : 'Velja orkuleið'
  }

  return (
    <div className={styles.selectPackage}>
      {properties.map((item, i) => {
        const label = `${item.address}, `.concat(
          item.fNumber
            ? `${item.postalCode} ${item.city}, ${item.fNumber}`
            : `${item.postalCode} ${item.city}`
        )

        if (isMobile) {
          return (
            <Fragment key={JSON.stringify(item)}>
              <p className={styles.address__mobileLabel}>{label}</p>

              <AccordionContainer title={showModalButton(item.product)}>
                <PackageAccordion
                  onSelectPackage={(packageId) => {
                    selectProduct(packageId, item?.ean || item.fNumber)
                  }}
                  product={findProduct(item?.ean || item.fNumber)}
                />
              </AccordionContainer>
            </Fragment>
          )
        }

        return (
          <Fragment key={JSON.stringify(item)}>
            <CheckLarge
              name="address"
              value="item.address"
              buttonText={showModalButton(item.product)}
              defaultChecked={item.selected}
              label={label}
              onChange={(e) => {
                selectCheckbox(e.currentTarget.checked, i)
              }}
              onButtonClick={() => {
                setActiveProperty(item?.ean || item.fNumber)
              }}
            />
          </Fragment>
        )
      })}

      <Modal
        active={modalVisible && Boolean(activeProperty)}
        className={styles.selectPackage__modal}
        onClose={() => {
          setModalVisible(false)
          setActiveProperty(null)
        }}
      >
        <div>
          <PackageList
            onSelectPackage={(packageId) => {
              selectProduct(packageId, activeProperty || '')
            }}
            product={findProduct(activeProperty)}
          />

          <div className={styles.unselect_button}>
            <TransparentButton
              text="Velja orkuleið seinna"
              onClick={() => {
                if (findProduct(activeProperty)) {
                  selectProduct('', activeProperty || '')
                }
                setModalVisible(false)
                setActiveProperty(null)
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}
